export const Experiments: Record<string, number> = {
    SPIDERS_CONTEXTUAL_IDENTIFICATION_FLOW: 4249,
    SPIDERS_CTX_REG_BRIEF_AND_MATCH: 4353,
    LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 4874,
    LYNXES_MODERN_HEADER: 4880,
};

export const ROLLOUTS: Record<string, number> = {};

export const ExperimentsConfig: Record<string, object> = {};

export const AllocationGroups = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
} as const;
